import { render, staticRenderFns } from "./item.vue?vue&type=template&id=cbb4a6b6&scoped=true&"
import script from "./item.js?vue&type=script&lang=js&"
export * from "./item.js?vue&type=script&lang=js&"
import style0 from "./item.vue?vue&type=style&index=0&id=cbb4a6b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbb4a6b6",
  null
  
)

export default component.exports